<template>
  <div class="main-content">
    <div class="h2"><strong>輸入驗證碼</strong></div>
    <div class="subtitle">
      已經有帳戶了嗎？<a href="#" @click="$store.commit('setLoginCurrentContent', 'login')">帳戶登錄</a>
    </div>

    <div class="form-div">
      <input type="text" class="form-input" id="input-code" placeholder=" " v-model.lazy="reset_password.check_sum">
      <label for="input-code" class="form-label">輸入驗證碼</label>
    </div>
    <div class="send-bag">
      <div id="error-password" class="text-danger"></div>
      <button class="form-button bg-success" @click="sentCheckSum">送出驗證碼</button>
    </div>

    <hr>
    <copyright-component></copyright-component>
  </div>
</template>

<script>
import CopyrightComponent from '../layouts/CopyrightComponent.vue';
import { validation } from '../mixins/validation.js';
import { axiosMixins } from '../mixins/axiosErrorMessage.js';

export default {
  mixins: [validation, axiosMixins],
  data() {
    return {
      reset_password: {
        check_sum: ''
      }
    }
  },
  methods: {
    sentCheckSum() {
      if (!this.validateBeforeSubmit()) { return }
      const error_element = this.$el.querySelector('#error-password')
      const axios_data = { code: this.reset_password.check_sum };
      axios.post(base_url + '/api/verify/verify-code', axios_data)
        .then((response) => {
          if (response.data.status === "success") {
            const history_component = this.$store.getters.loginHistoryContent;
            if (history_component === 'forget-password') {
              this.$store.commit('setResetpasswordVerifyToken', response.data.token);
              this.$store.commit('setLoginCurrentContent', 'reset-password');
            } else if (history_component === 'verification-email') {
              // 若登入裝置為 ha
              if (window.location.href.endsWith("/ha")) {
                this.$router.push({ name: "ha-page" });
              } else {
                this.$router.push({ name: 'home' });
              }
            }
          } else {
            error_element.innerHTML = "驗證系統忙碌，請稍後再試";
          }
        }).catch((error) => {
          this.axiosMessage(error);
          error_element.innerHTML = "驗證系統忙碌，請稍後再試";
        });

      setTimeout(() => {
        if (error_element.innerHTML !== "") {
          error_element.innerHTML = "";
        }
      }, 3000);
    }
  },
  components: { CopyrightComponent },
}
</script>
